<template>
    <div class="form">
        <h4 class="step-title">
            What type of coverage are you looking for?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <button-list v-bind:items="coverageTypes" v-bind:onclick="complete"></button-list>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "RequestedCoverageType",
        components: {
            ButtonList
        },
        data: function() {
            return {
                coverageTypes: [
                    { text: "State Minimum", value: "Minimum" },
                    { text: "Standard", value: "Standard" },
                    { text: "Preferred", value: "Premium" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(coverageType) {
                this.lead.requestedCoverageType = coverageType;
                this.$emit("complete", this.$options.name, coverageType);
            }
        }
    }
</script>
